<template>
  <v-row no-gutters justify="center" align="center">
    <div class="pa-6" style="max-width: 600px;">
      <v-row no-gutters justify="center" align="center">
        <v-icon color="accent" style="font-size: 60px;">sentiment_dissatisfied</v-icon>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-4 text-h5 text-center">
        Indeego subit actuellement quelques difficultés, nous faisons notre maximum pour résoudre le problème au plus vite.
      </v-row>
      <v-row no-gutters justify="center" align="center" class="pt-6">
        Désolé pour ce désagrément.
      </v-row>
    </div>
  </v-row>
</template>

<script>
export default {
};
</script>
